<template>
  <div class="included" :class="{ _open: isOpen }">
    <div class="included__header" @click="toggle">
    

      <div 
        class="included__badge" 
        :class="{ [props.iconClass]: props.iconClass }"
      >
        <component 
          :is="icon_comp(props.icon)" 
          class="included__badge-icon"
        />
      </div>

      <div class="included__title">
        {{ props.title }}
      </div>

      <vDown class="included__icon vicon-black" :class="{ _open: isOpen }"/>
    </div>

    <div class="included__content">
      <InsertHtml class="included__html" v-bind="props.included" />
    </div>
  </div>
</template>

<style lang="scss" src="./IncludedBlock.scss"></style>

<script setup>
import { ref } from 'vue'
import DefaultIcon from '@/assets/vicons/seal-warning.vue'
import vChefHat from '@/assets/vicons/chef-hat.vue'
import vSealWarning from '@/assets/vicons/seal-warning.vue'
import vSealCheck from '@/assets/vicons/seal-check.vue'
import vDown from '@/assets/vicons/chevron-down.vue'
import InsertHtml from '@/comp/IncludedBlock/InsertHtml.vue'


const ICONS = {
  included: vSealCheck,
  excluded: vSealWarning,
  restaurants: vChefHat,
}

const props = defineProps({
  included: {
    type: Object,
  },
  title: {
    type: String,
    default: 'Дополнительная информация'
  },
  icon: {
    type: String,
  },
  iconClass: {
    type: String,
    default: null
  }
})

//console.log('props.insdf', props.included )

const isOpen = ref(false)

const toggle = () => {
  isOpen.value = !isOpen.value
}

const icon_comp = (name) => {
  return name in ICONS ? ICONS[name] : DefaultIcon
}
</script>
